
import Vue from 'vue'
import Transformer from '../../transformers/purchase/freight'

export default (freightId, payload,original) => {
  const transformed = Transformer.send(payload)
  return Vue.$http.put(`purchase/freight/${freightId}/`, transformed)
    .then(response => {
      const data = response.data
      return data
    })
} 


// WEBPACK FOOTER //
// ./src/services/purchase/updateFreight.js